<template>
  <div class="containerSearchDirection">
    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i class="uil uil-search glyphicon iconInput" v-show="!coordenada"></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="coordenada"
            @click="limpiar"
          ></i>
          <vs-input
            type="text"
            class="inputNumberDirection"
            placeholder="Latitud, Longitud  (ej: -16.3989, -71.5369)"
            v-model="coordenada"
            @keydown.enter="buscar"
          />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div v-if="nivel_search" :class="classForPrecision">
          <label>{{ nivel_search }}</label>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <el-button class="btnSearchDirection" type="success" @click="buscar"
          >Buscar</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "SearchCoordenadaSedapar",

  data() {
    return {
      coordenada: "",
      urlBase: "",
      nivel_search: "",
      classForPrecision: "",
    };
  },

  created() {
    this.urlBase = process.env.VUE_APP_GEOCODING;
  },

  computed: {
    ...mapState(["map", "user"]),
  },

  methods: {
    limpiar() {
      this.coordenada = "";
      this.nivel_search = "";
    },

    aviso(message) {
      this.$notify({ title: "Aviso", message, type: "warning" });
    },

    // Acepta "-16.3989, -71.5369" o "-16.3989 -71.5369"
    parsearCoordenada() {
      const partes = this.coordenada.trim().split(/[\s,;]+/).filter(Boolean);
      if (partes.length !== 2) return null;
      const lat = parseFloat(partes[0]);
      const lon = parseFloat(partes[1]);
      if (isNaN(lat) || isNaN(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
      return { lat, lon };
    },

    removeLayers() {
      if (!this.map) return;
      const marker = this.$store.getters.layerMarkerSearcher;
      if (marker) this.map.removeLayer(marker);
      const buildings = this.$store.getters.layerMarkerBuildingsSearcher;
      if (buildings) this.map.removeLayer(buildings);
    },

    buscar() {
      if (!this.coordenada) {
        this.aviso("Ingrese las coordenadas, por favor");
        return;
      }
      const coord = this.parsearCoordenada();
      if (!coord) {
        this.aviso("Formato inválido. Use: latitud, longitud (ej: -16.3989, -71.5369)");
        return;
      }

      this.removeLayers();

      const email = this.user && this.user.email ? this.user.email : "";
      const url = `${this.urlBase}latlon=${coord.lat},${coord.lon}&maps=true&mapsaccount=${email}`;

      axios
        .get(url)
        .then((response) => {
          if (response.data && response.data.status === "OK") {
            this.mostrarResultado(response.data);
          } else {
            this.aviso("No se encontraron resultados");
          }
        })
        .catch((error) => {
          console.log(error);
          this.aviso("Error al consultar la coordenada");
        });
    },

    mostrarResultado(result) {
      const first = result.results && result.results[0];
      if (!first) {
        this.aviso("No se encontraron resultados");
        return;
      }

      const coords = first.geometry.coordinates;
      this.$store.commit("SET_LATITUD_GENERAL", coords.lat);
      this.$store.commit("SET_LONGITUD_GENERAL", coords.lon);

      this.evaluatePrecision(first.geometry.geocoding_type, first.result_types || []);

      const latlng = L.GeoJSON.coordsToLatLng([coords.lon, coords.lat]);
      this.map.setView(latlng, 18, { duration: 1 });

      const icon = new L.Icon({
        iconUrl: require("../../assets/images/icon_marker.png"),
        iconAnchor: [12, 30],
      });

      const marker = L.marker(latlng, { icon })
        .addTo(this.map)
        .bindPopup(first.standard_address)
        .openPopup();

      this.$store.commit("SET_LAYER_MARKER", marker);
      this.$store.commit("SET_PLACE_ID", first.place_id);
      this.$store.commit("SET_ADDRESS", first.standard_address);
    },

    evaluatePrecision(tipo, detalle) {
      if (tipo === "DOOR" || tipo === "INTERPOLATED") {
        this.classForPrecision = "precision-alta";
        this.nivel_search = "Precisión Alta";
      } else if (
        tipo === "CENTER" &&
        (detalle.includes("route") || detalle.includes("sublocality"))
      ) {
        this.classForPrecision = "precision-media";
        this.nivel_search = "Precisión Media";
      } else {
        this.classForPrecision = "precision-baja";
        this.nivel_search = "Precisión Baja";
      }
    },
  },
};
</script>